import React from "react"

export default function LongAnswer({name, changeWriteAnswer, isPassed}) {

  const styles = {
    backgroundColor: 'rgba(255, 253, 152, 0.76)',
  }

  const style = isPassed ? styles : null

  return (
    <>
      <label className="test-check-text">Ваш ответ:</label>
      <textarea style={style} placeholder="Введите свой ответ" name={`a${name}`} onChange={(e) => changeWriteAnswer(e)} disabled={isPassed}/>
      {isPassed && <label className="test-check-text">Ваш ответ проверяется специалистом</label>}
    </>
  )
}